import PropTypes from 'prop-types';

import VideoPlayer from '../VideoPlayer';
import VideoTutorialTranscript from '../VideoTutorialTranscript';
import ProTip from '../../ProTip';
import RichText from '../../../Core/RichText';
import Container from '../../../Core/Container';

import {
  Wrapper,
  VideoWrapper,
  VideoDescription,
  ProTipWrapper,
  VideoHeader,
} from './styles';

const VideoTutorialVideoPlayer = ({ data }) => {
  if (!data) return null;

  const {
    videoTitle,
    videoLabel,
    videoDescription,
    videoId,
    transcript,
    showTranscriptLabel,
    hideTranscriptLabel,
    proTip,
    videoLongDescription,
  } = data;

  return (
    <Wrapper>
      {videoTitle && <VideoHeader>{videoTitle}</VideoHeader>}
      {videoLongDescription ? (
        <VideoDescription>
          <Container className="auto-margin">
            <RichText document={videoLongDescription} />
          </Container>
        </VideoDescription>
      ) : (
        videoDescription && (
          <VideoDescription>
            <Container className="auto-margin">
              <RichText document={videoDescription} />
            </Container>
          </VideoDescription>
        )
      )}
      <Container className="auto-margin">
        <VideoWrapper>
          <VideoPlayer
            type="youtube"
            url={`https://www.youtube.com/watch?v=${videoId}`}
            playing={false}
            title={videoLabel}
          />
        </VideoWrapper>
      </Container>
      {transcript && (
        <VideoTutorialTranscript
          transcript={transcript}
          showTranscriptLabel={showTranscriptLabel}
          hideTranscriptLabel={hideTranscriptLabel}
        />
      )}
      {proTip && (
        <Container className="auto-margin">
          <ProTipWrapper className="video-tip">
            <ProTip data={proTip} />
          </ProTipWrapper>
        </Container>
      )}
    </Wrapper>
  );
};

VideoTutorialVideoPlayer.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default VideoTutorialVideoPlayer;
